import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/presse/Presse.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/ratgeber/RatgeberGuides.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/ratgeber/Alles-über-den-autoverkauf.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/ratgeber/Autorecht.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/ratgeber/Autovergleich.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/common/Common.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/common/StickyWidget.js");
